import React, { useState } from 'react'
import Input from 'components/input'
import Menu, { MenuProps } from 'components/menu'
import { Cross } from 'components/icons'
import { INITIAL_CONTEXT_MENU_STATE } from 'app-constants'

const SearchMenu: React.FC<MenuProps> = ({ id, menuState, setMenuState, width }) => {
  const [search, setSearch] = useState<string>('')

  const handleSearch = () => {
    let strFound
    if (window.find) {
      strFound = self.find(search, false, false, true, false, false, false)
      if (strFound && self.getSelection && !self.getSelection()?.anchorNode) {
        strFound = self.find(search)
      }
      if (!strFound) {
        strFound = self.find(search, 0, 1)
        while (self.find(search, 0, 1)) continue
      }
    }
  }

  return (
    <Menu id={id} menuState={menuState} setMenuState={setMenuState} width={width}>
      <div className="p-0 m-2.5 list-none">
        <div className="flex items-center">
          <Input
            type="text"
            className="w-[200px] mr-auto"
            placeholder="Search Document"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearch(event.target.value)}
          />

          <div
            className="flex items-center justify-center bg-surface-sunken hover:bg-surface-strong cursor-pointer rounded transition-all ml-[5px] p-[5px]"
            onClick={() => handleSearch()}
          >
            Find
          </div>

          <div
            className="flex items-center justify-center bg-surface-sunken hover:bg-surface-strong cursor-pointer rounded transition-all ml-[5px] p-[5px]"
            onClick={() => {
              setSearch('')
              setMenuState(INITIAL_CONTEXT_MENU_STATE)
            }}
          >
            <Cross />
          </div>
        </div>
      </div>
    </Menu>
  )
}

export default SearchMenu
